module.exports = __webpack_public_path__ + "static/media/bg_row.4178e256.png";